import React from 'react';

export const Logo = () => (
  <div style={{ height: '100%', display: 'flex', justifyContent: 'center' }}>
    <img style={{ width: 70 }} src="https://static.bit.dev/extensions-icons/rename.svg" />
  </div>
);
